// Reliable same-origin file download.
//
// A plain <a download> to a static asset can, inside a PWA, be turned into a
// navigation request that the service worker answers with index.html — so the
// user saves an HTML file instead of the real asset. Fetching the bytes and
// saving a Blob avoids that (a fetch is not a navigation), and also works
// around iOS Safari's flaky `download` attribute.
export async function downloadUrl(url, filename) {
  const name = filename || url.split('/').pop() || 'download'
  const res = await fetch(url, { cache: 'no-store' })
  if (!res.ok) throw new Error(`Download failed (${res.status})`)
  const blob = await res.blob()
  const objectUrl = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = objectUrl
  a.download = name
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(objectUrl)
}
